import { render } from "./FaxLogs.vue?vue&type=template&id=0cfc44a2"
import script from "./FaxLogs.vue?vue&type=script&lang=js"
export * from "./FaxLogs.vue?vue&type=script&lang=js"

import "./FaxLogs.vue?vue&type=style&index=0&id=0cfc44a2&lang=css"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__